import React, {useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from 'react-router-dom';
import BrandLogo from '../../../../styles/images/logo/full-vertical.svg';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { handleChangeTimerTimeCourierVerificationPage, 
    handleChangeInputCourierVerificationPage } from "../../../../redux/actions/pages/courier/verification";
import { handleChangeInputCourierLoginPage, handleChangeCourierProfileData, handleChangeCourierToken } from "../../../../redux/actions/pages/courier/login";
import { COURIER_LOGIN, COURIER_ACTIVATION_POST } from '../../../../apis'; 
import apiRequest from '../../../../utils/apiRequest';

const CourierVerify = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const { courierPhoneNumber } = useSelector(state => state.courierLogin);
	const { code, timerTime, inputClass, errorTxt } = useSelector(state => state.courierVerification);
	const { isBackdropLoading } = useSelector(state => state.allLoaders);

	useEffect(() => {
        handleTimerTime();
        // eslint-disable-next-line
    }, [timerTime]);

    let setTimeOut;
    const handleTimerTime = () => {
        if (timerTime > 0)
            setTimeOut = setTimeout(() => {
                if (timerTime > 0) {
                    dispatch(handleChangeTimerTimeCourierVerificationPage(timerTime - 1));
                } else
                    clearTimeout(setTimeOut);
            }, 1000);
        else {
            if (timerTime !== 0)
                dispatch(handleChangeTimerTimeCourierVerificationPage(0));
        }
    };

    const handleChangeInputs = (event) => {
        const {name, value} = event.target;
        dispatch(handleChangeInputCourierVerificationPage(name, changeNumberPersianAndArabic(value)));
    };

    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    }

    const apiLogin = () => {
    	if(! isBackdropLoading) {
    		apiRequest({
			    dispatch,
			    endpoint: COURIER_LOGIN,
			    method: 'post',
			    data: { mobile: courierPhoneNumber },
			    token: null,
			    successMessage: null,
			    onSuccess: (res) => {
                    dispatch(handleChangeTimerTimeCourierVerificationPage(parseInt(res.timer_time)));
			    },
		  	});
    	}
    };

    const apiActivation = (event) => {
    	event.preventDefault();

    	if(! isBackdropLoading) {
    		if(code.length === 0) {
	    		dispatch(handleChangeInputCourierVerificationPage('inputClass', 'Input-InputWrapper-error'));
	    		dispatch(handleChangeInputCourierVerificationPage('errorTxt', 'لطفا این قسمت را خالی نگذارید!'));
	    	}
	    	else if(code.length !== 4) {
	    		dispatch(handleChangeInputCourierVerificationPage('inputClass', 'Input-InputWrapper-error'));
	    		dispatch(handleChangeInputCourierVerificationPage('errorTxt', 'کد باید  4 رقم باشد!'));
	    	}
	    	else {
	    		dispatch(handleChangeInputCourierVerificationPage('inputClass', 'Input-InputWrapper-d'));
	    		dispatch(handleChangeInputCourierVerificationPage('errorTxt', ''));


	    		apiRequest({
				    dispatch,
				    endpoint: COURIER_ACTIVATION_POST,
				    method: 'post',
				    data: { code, mobile: courierPhoneNumber },
				    token: null,
				    successMessage: null,
				    onSuccess: (res) => {
				      	dispatch(handleChangeInputCourierVerificationPage('code', ''));
                        dispatch(handleChangeInputCourierVerificationPage('timerTime', 0));

                        dispatch(handleChangeInputCourierLoginPage('courierPhoneNumber', ''));

                        dispatch(handleChangeCourierProfileData(res.info));
                        dispatch(handleChangeCourierToken(res.token));
				    },
			  	});
	    	}
    	}
    };


	const handleOnInputFocus = (event) => {
        if(errorTxt.length === 0)
        	dispatch(handleChangeInputCourierVerificationPage('inputClass', 'input-focused'));
    };

    const handleOnInputBlur = () => {
        if(errorTxt.length === 0)
        	dispatch(handleChangeInputCourierVerificationPage('inputClass', 'Input-InputWrapper-d'));
    };


    return (

    	<main className="min-h-full w-full flex items-center flex-col bg-neutral-000 justify-center" style={{height: '100vh'}}>
    		<div className="lg:border-complete-200 rounded-medium p-5 lg:p-8 flex flex-col items-center justify-start lg:justify-center account-wrapper-AccountWrapper-mainBox">
    			<div className="w-full relative flex items-center justify-center mb-3">
    				<div className="flex cursor-pointer right-0 text-neutral-700 transition-all duration-300 ease-out 00 cursor-pointer fixed lg:absolute  logo-Logo-icon">
						<ArrowForwardIcon sx={{fontSize: '24px', fill: 'var(--color-icon-high-emphasis)'}} onClick={() => navigate(-1)} />
    				</div>
    				<Link to='/' className="hidden lg:block">
						<div className="transform transition-all duration-500 ease-out">
							<img className="inline-block" src={BrandLogo} width={100} alt='دیجیکالا' style={{objectFit: 'contain'}} />
						</div>
					</Link>
    			</div>
    			<div className="w-full">
    				<h1 className="text-h4 text-neutral-900 text-right w-full mt-4">کد تایید را وارد کنید</h1>
		  			<p className="text-body-2 text-neutral-700 my-4 text-right w-full">کد تایید برای شماره  {courierPhoneNumber} پیامک شد!</p>

		  			<form>
		  				<label className="FormComponentFrame-FormComponentFrame w-full FormComponentFrame-FormComponentFrame-normal">
			  				<div onFocus={handleOnInputFocus} 
			  						onBlur={handleOnInputBlur}  
			  						className={`FormComponentFrame-FormComponentFrame-input-container px-2 flex items-center relative text-neutral-800 bg-neutral-100 lg:bg-neutral-000 ${inputClass}`}>
			  					<div className="grow text-body-3">
			  					<input name="code" 
			  						value={code} 
			  						onChange={handleChangeInputs} 
			  						className="px-2 TextField-TextField-input text-subtitle w-full TextField-TextField TextField-TextField-secondary-w text-subtitle w-full py-5 lg:py-2 rounded-medium text-center styles-codeInput-trackingOtp"
			  						type="text"
			  						inputMode="numeric"
								  	pattern="[0-9]*"
								  	inputUntil="on" />
			  					</div>
			  				</div>
			  				<p className="text-body-2 text-hint-text-error">{errorTxt}</p>
		  				</label>
		  			</form>
					{timerTime === 0 ?
					<div className="w-full flex items-center justify-center mb-6 mt-4 text-caption user-select-none">
						دریافت مجدد کد از طریق
						<span onClick={apiLogin} className="flex items-center text-secondary-500 mx-2 cursor-pointer">
							پیامک
							<div className="flex">
								<ChevronLeftIcon sx={{fontSize: '20px', fill: 'var(--color-icon-secondary)'}} />
							</div>
						</span>
					</div>
					:
					<p className="w-full mt-4 text-center text-body-2 py-2 text-neutral-700">
						<span className="w-10 inline-block mx-1 text-center">{timerTime}</span>
						 ثانیه مانده تا دریافت مجدد کد
					</p>
					}
		  			<button className="relative flex items-center user-select-none styles-btn text-button-1 styles-btn-large styles-btn-primary rounded-medium w-full mt-4" 
		  					type="submit"
		  					onClick={apiActivation} >
		  				<div className="flex items-center justify-center relative grow">تایید</div>
	  				</button>
    			</div>
    		</div>
    	</main>

    );
}

export default CourierVerify;